import axios from "axios";
import { handleResponse } from "../../utils";
export const settingService = {
  getAvailableTimeZones,
  getAvailableUsers,
  changeUserSettings,

  getChannnelList,
  getPlatformsList,
  getSlaCalenderList,
};

function getPlatformsList() {
  return axios
    .get("Configuration/platforms/list")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getChannnelList() {
  return axios
    .get("Configuration/channels/list")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getSlaCalenderList() {
  const params = {
    Year: new Date().getFullYear(),
    IncludeNextYear: true,
  };
  return axios
    .get("Configuration/slaconfig/getCalendars", {
      params: params,
    })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getAvailableTimeZones() {
  return axios
    .get("Configuration/timezones")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getAvailableUsers() {
  return axios
    .get("Configuration/ListUsers")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function changeUserSettings(data) {
  return axios
    .put("Configuration/user/settings/save", data)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}
